import PokemonCard from "./PokemonCard";
export default PokemonCard;